const data = {};
export const Storage = {
 set(key, value) {
    data[key] = value;
  },
  get(key, defaultValue = undefined) {
    return data[key] || defaultValue;
  },
};
